module.exports = __webpack_public_path__ + "img/testimonial-user-1.ccf06429.png";